import { useTranslation } from "react-i18next";
import ExistingPortalUsers from "./ExistingPortalUsers";
import PendingPortalUsers from "./PendingPortalUsers";
import InactivePortalUsers from "./InactivePortalUsers";
import { useCallback, useState } from "react";
import css from "../../../../ProjectSetings/UserAdminstration/ProjectUsers/ListUsers/ListUserAndRules.module.css";
import css1 from "./index.module.css";
import UserNameTagComponent from "../../../../../cubeComponent/html/UserNameTagComponent";

function PortalUsers({ id, disableHeaderText }) {
  const { t } = useTranslation();
  const getUserAvatar = (id) => <UserNameTagComponent id={id} />;

  const existingUserContent = useCallback(() => <ExistingPortalUsers id={id} getUserAvatar={getUserAvatar} />, []);
  const pendingUserContent = useCallback(() => <PendingPortalUsers id={id} getUserAvatar={getUserAvatar} />, []);
  const inactiveUserContent = useCallback(() => <InactivePortalUsers id={id} getUserAvatar={getUserAvatar} />, []);
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className={css1.wrapperClass}>
      {!disableHeaderText && (
        <>
          <span className={css1.headerText} data-testid="portalUsersText">
            {t("Portal Users")}
          </span>
          <div className={css1.headerData} data-testid="listOfAllUsersText">
            {t("List of all users in this portal")}
          </div>
        </>
      )}

      <div className={css.ProjectUserswrapper}>
        <div className={`${css.headerWrapper} border-system_colour_44`} data-testid="usersBtnWrapper">
          <div className={css.userHeaderButton} data-testid="usersTab">
            <div
              className={activeTab === "users" ? css.activeButton : css.singleButtonStyle}
              onClick={() => {
                setActiveTab("users");
              }}
            >
              {t("Users")}
            </div>
            {activeTab === "users" && <div className={css.headerButtonSelectionBar} />}
          </div>

          <div className={css.userHeaderButton} data-testid="invitedTab">
            <div
              className={activeTab === "invitedUsers" ? css.activeButton : css.singleButtonStyle}
              onClick={() => {
                setActiveTab("invitedUsers");
              }}
            >
              {t("Invited")}
            </div>
            {activeTab === "invitedUsers" && <div className={css.headerButtonSelectionBar} />}
          </div>

          <div className={css.userHeaderButton} data-testid="inactiveTab">
            <div
              className={activeTab === "inactiveUsers" ? css.activeButton : css.singleButtonStyle}
              onClick={() => {
                setActiveTab("inactiveUsers");
              }}
            >
              {t("Inactive")}
            </div>
            {activeTab === "inactiveUsers" && <div className={css.headerButtonSelectionBar} />}
          </div>
        </div>

        <div className={css1.portalUsersContent} data-testid="portalUsersContent">
          {activeTab === "users" && existingUserContent()}
          {activeTab === "invitedUsers" && pendingUserContent()}
          {activeTab === "inactiveUsers" && inactiveUserContent()}
        </div>
      </div>
    </div>
  );
}

export default PortalUsers;
